module.exports = __webpack_public_path__ + "img/5.1.385b484d.jpg";